// extracted by mini-css-extract-plugin
module.exports = {"wi3e7ul":"wi3e7ul"};